import SoftPhoneModule from '..';
import { phoneState } from '../state';

const handleCheckWebPhoneRegistration = () => {
  // do not disconnect if there are any active calls.
  if (Object.keys(phoneState.callList).length !== 0) {
    return;
  }

  if (phoneState.registrationOverwritten && phoneState.phoneConnected) {
    SoftPhoneModule.disconnectSoftPhone(false);
  }
};

export default handleCheckWebPhoneRegistration;
